const isListingProductPrice = (price)=>{
    return 'originalPrice' in price;
};
const getPriceSpecificationConfig = (pricing, vat)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const originalPrice = isListingProductPrice(pricing) ? pricing.originalPrice : pricing.value.centAmount;
    var ref10, _centAmount;
    const discountedPrice = isListingProductPrice(pricing) ? (ref10 = (ref = pricing.discount) === null || ref === void 0 ? void 0 : ref.price) !== null && ref10 !== void 0 ? ref10 : 0 : (_centAmount = (ref1 = pricing.discounted) === null || ref1 === void 0 ? void 0 : ref1.value.centAmount) !== null && _centAmount !== void 0 ? _centAmount : 0;
    const currency = isListingProductPrice(pricing) ? pricing.currencyCode : pricing.value.currencyCode;
    const validFrom = isListingProductPrice(pricing) ? (ref2 = pricing.discount) === null || ref2 === void 0 ? void 0 : ref2.validFrom : (ref3 = pricing.discounted) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.discount) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.obj) === null || ref5 === void 0 ? void 0 : ref5.validFrom;
    const validThrough = isListingProductPrice(pricing) ? (ref6 = pricing.discount) === null || ref6 === void 0 ? void 0 : ref6.validUntil : (ref7 = pricing.discounted) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.discount) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.obj) === null || ref9 === void 0 ? void 0 : ref9.validUntil;
    const price = discountedPrice > 0 ? discountedPrice : originalPrice;
    const vatRate = vat ? vat : 0;
    return {
        price,
        vatRate,
        currency,
        validFrom,
        validThrough
    };
};

export { getPriceSpecificationConfig };
//# sourceMappingURL=get-price-specification-config.js.map
